import { AT } from '../../../actions/actionTypes';
import { SendState, Transfer } from './model';
import { SendStateDefault } from './defaults';
import { PKey } from '../../devices';
import * as TxReducer from './transfer.reducer'
import Logger from '../../../libs/logger';  import { LogArea } from '../../../libs/logger/const';

const defaultState: SendState = SendStateDefault;

export const updateTransfer = (
  state = defaultState,
  transfer: Transfer
): SendState => ({
  ...state,
  transfer,
});

export const updateDevices = (
  state = defaultState,
  devices: PKey[]
): SendState => ({
  ...state,
  transfer: TxReducer.setDevices(state.transfer, devices),
});

export default function (state = defaultState, action: any) {
  switch (action.type) {
    case AT.DIALOG_TRANSFER_SEND_UPDATE_TRANSFER: {
      Logger.info(
        [AT.DIALOG_TRANSFER_SEND_UPDATE_TRANSFER, action],
        LogArea.Redux
      );
      const transfer: Transfer = action.payload;
      return updateTransfer(state, transfer);
    }

    case AT.DIALOG_TRANSFER_SEND_UPDATE_DEVICES: {
      Logger.info(
        [AT.DIALOG_TRANSFER_SEND_UPDATE_DEVICES, action],
        LogArea.Redux
      );
      const devices: PKey[] = action.payload;
      return updateDevices(state, devices);
    }

    default: {
      return state;
    }
  }
}
